import User_store from '@/store/User_store'
import { info_icon } from 'constant/AllIcons'
import { getAuthKey } from 'constant/functions'
import {
  MixpanelEventName,
  MixpanelPropertiesName,
  MixpanelPropertiesValues,
  MixpanelTracking,
} from 'constant/mixpnael'
import { site_url } from 'constant/url'
import { pricing_plans } from 'data/PringPlanData'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import SMEPricing from '../Pricing/SMEPricing'
import AnnualToggle from '../Pricing/AnnualToggle'
import PricingModelToggle from '../Pricing/PricingModelToggle'
import EnterPrisePricing from '../Pricing/EnterPrisePricng'
import SMEPricingModel2 from '../Pricing/SMEPricingModel2'
import SMBPricingBlocks from '../Pricing/SMBPricingBlocks'
import { useGetPlansQuery } from '@/redux/features/plans/plansApi'

function PricingTablesMarketplace() {
  const [is_yearly, setIsYearly] = useState(true)
  const [is_business_model, setISBusinessModel] = useState(false)
  const [userDetails, setUserDetails] = useState(null)
  const [tenantDetails, setTenantDetails] = useState(null)

  const router = useRouter()

  useEffect(() => {
    if (getAuthKey() !== undefined) {
      User_store.user_details((resp) => {
        setUserDetails(resp)
      })
      User_store.tenant_details((resp) => {
        setTenantDetails(resp)
      })
    }
  }, [router])

  return (
    <>
      <section className="bg-gradient-to-b from-white to-gray-100">
        <div className="max-w-7xl w-full mx-auto px-4 sm:px-6">
          <div className="  pb-12  pt-16 md:pb-20">
            {/* Section header */}
            <div className="max-w-3xl mx-auto text-center pb-12">
              <h1 className="h1 mb-4 text-gray-900 " data-aos="zoom-y-out">
                Flexible Pricing for everyone.
              </h1>
              <p className="text-xl text-gray-900" data-aos="zoom-y-out" data-aos-delay="150">
                Tradly Platform comes with mission critical operational features to grow your
                project. CMS, Commerce, Booking, Payin/Payout, Wallet, Escrow Account, Commission,
                Subscription, etc.
              </p>
            </div>
            <div className="max-w-3xl mx-auto text-center pb-12">
              <p className="text-xl text-green-400" data-aos="zoom-y-out" data-aos-delay="150">
                All Plans comes with SuperAdmin, Editor, Headless API, Free Integrations & Pre-built
                Templates.
              </p>
            </div>

            {/* Pricing tables */}
            <div className="flex  flex-wrap items-center justify-between mb-16 ">
              <PricingModelToggle
                is_business_model={is_business_model}
                setISBusinessModel={setISBusinessModel}
              />
              {!is_business_model && (
                <AnnualToggle setIsYearly={setIsYearly} is_yearly={is_yearly} />
              )}
            </div>
            {/* SME pricing */}
            {is_business_model ? (
              <EnterPrisePricing />
            ) : (
              <SMEPricing
                userDetails={userDetails}
                tenantDetails={tenantDetails}
                is_annual={is_yearly}
              />
            )}
          </div>
        </div>
      </section>

      {!is_business_model && <SMBPricingBlocks />}
    </>
  )
}

export default PricingTablesMarketplace
